import {TargetPlatformReview} from './target-platform-review.model';

/**
 * Ordre d'affichage des plateformes dans le paramétrage : les trois que l'application connaît
 * nommément, puis le cas général qui recueille toutes les autres.
 */
export const TARGET_PLATFORM_REVIEWS: TargetPlatformReview[] = [
    TargetPlatformReview.GOOGLE,
    TargetPlatformReview.TRIPADVISOR,
    TargetPlatformReview.TRUSTPILOT,
    TargetPlatformReview.OTHER,
];
